import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import Excerpt from './components/Excerpt';

/**
 * Rich excerpts render real post HTML, which only exists on a fully
 * serialized post — so they still include the post. Plain excerpts come from
 * the synopsisExcerpt attribute the backend serializes on each discussion,
 * with no posts in the payload at all.
 */
function richExcerptsInPlay() {
  return Boolean(app.forum.attribute('synopsis.rich_excerpts')) || app.store.all('tags').some(tag => {
    var _tag$richExcerpts;
    return Boolean((_tag$richExcerpts = tag.richExcerpts) == null ? void 0 : _tag$richExcerpts.call(tag));
  });
}
export default function addSummaryExcerpt() {
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (!richExcerptsInPlay()) return;
    if (typeof params.include === 'string') {
      params.include = [params.include];
    } else {
      params.include = params.include || [];
    }
    if (app.forum.attribute('synopsis.excerpt_type') === 'first') {
      params.include.push('firstPost');
    } else {
      params.include.push('lastPost');
    }
  });
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    var _app$session$user$pre, _tag, _tag2, _tag3, _app$session$user$pre2;
    const discussion = this.attrs.discussion;
    if (app.session.user && !((_app$session$user$pre = app.session.user.preferences()) != null && _app$session$user$pre.showSynopsisExcerpts)) {
      return;
    }
    const tags = discussion.tags();
    let tag;
    if (tags) {
      tag = tags[tags.length - 1];
    }
    const excerptLength = typeof ((_tag = tag) == null ? void 0 : _tag.excerptLength()) === 'number' ? (_tag2 = tag) == null ? void 0 : _tag2.excerptLength() : app.forum.attribute('synopsis.excerpt_length');

    // The tag override is a nullable boolean — null means inherit the global
    // setting. (Checking `typeof === 'number'` here meant the override never
    // applied at all.)
    const tagRich = (_tag3 = tag) == null ? void 0 : _tag3.richExcerpts();
    const richExcerpt = typeof tagRich === 'boolean' ? tagRich : Boolean(app.forum.attribute('synopsis.rich_excerpts'));
    const onMobile = app.session.user ? (_app$session$user$pre2 = app.session.user.preferences()) == null ? void 0 : _app$session$user$pre2.showSynopsisExcerptsOnMobile : false;

    // A length of zero means we don't want a synopsis for this discussion, so do nothing.
    if (excerptLength === 0) {
      return;
    }

    // When rich excerpts are in play anywhere, the payload carries the posts
    // and no attribute — so the post is the source for BOTH flavours here:
    // rich for tags that want it, contentPlain for tags that opted out.
    // Otherwise the plain attribute is the only source needed.
    const inPlay = richExcerptsInPlay();
    const excerptPost = inPlay ? app.forum.attribute('synopsis.excerpt_type') === 'first' ? discussion.firstPost() : discussion.lastPost() : null;
    const plainExcerpt = inPlay ? null : discussion.attribute('synopsisExcerpt');
    if (excerptPost || plainExcerpt) {
      const excerpt = m(Excerpt, {
        post: excerptPost,
        plain: plainExcerpt,
        length: excerptLength,
        richExcerpt: richExcerpt && Boolean(excerptPost)
      });
      items.add('excerpt', excerpt, -100);
      onMobile && items.add('excerptM', excerpt, -100);
    }
  });
}